import { get } from '../tools/http';

export default {
    state: {
        awards: [],
        competencies: [],
        jobOffers: [],
    },
    mutations: {
        writeAwards: (state, val) => state.awards = val,
        writeCompetencies: (state, val) => state.competencies = val,
        writeJobOffers: (state, val) => state.jobOffers = val,
    },
    actions: {
        getAwards: async ctx => {
            const response = await get('reporting', 'api/v1/report/listachievement?skip=0&take=3', null, true);

            if (!response) return;

            ctx.commit('writeAwards', response.data);
        },

        getCompetencies: async ctx => {
            const response = [
                {
                    name: 'Системное мышление',
                    val: 100,
                },
                {
                    name: 'Работа с ИТ-системами',
                    val: 66,
                },
                {
                    name: 'Межотрослевая коммуникация',
                    val: 5,
                },
            ];

            const onTimer = () => ctx.commit('writeCompetencies', response);

            setTimeout(onTimer, 500);
        },

        getJobOffers: async ctx => {
            const response = [
                {
                    text: 'Ведущий аналитик в Mail.ru Group',
                    url: '#',
                },
                {
                    text: 'Web-разработчик в KTS-Studio',
                    url: '#',
                },
                {
                    text: 'Web-дизайнер в Ситимобил',
                    url: '#',
                },
                {
                    text: 'Геймдизайнер в Mail.ru Group',
                    url: '#',
                },
            ];

            const onTimer = () => ctx.commit('writeJobOffers', response);

            setTimeout(onTimer, 500);
        },
    },
    getters: {
        awards: state => state.awards,
        competencies: state => state.competencies,
        jobOffers: state => state.jobOffers,
    },
};
